<div #mainMap class="main-map" [style.cursor]="cursor" gisWidgetDropArea>
  <ng-template #dynamic></ng-template>
</div>
